import { useToast } from "@/hooks/utils/useToast";
import {
    useCustomViews,
    useNavBarContent,
} from "@cs_teamwaydev/mailvista-sdk_react";
import { useTranslation } from "react-i18next";

const useDeleteView = () => {
    const customViews = useCustomViews();
    const { toast } = useToast();
    const { t } = useTranslation();
    const { refresh: refreshNavBarContent } = useNavBarContent();

    const deleteView = async (viewId: string): Promise<void> => {
        try {
            await customViews.deleteView(viewId);
            void refreshNavBarContent();
        } catch (error) {
            console.error(error);
            toast({
                title: t("errors.customViews.deleteView"),
                description: t("errors.global.description"),
                variant: "error",
            });
        }
    };

    return deleteView;
};

export default useDeleteView;
